module.exports = __webpack_public_path__ + "img/351.a43cc484.png";